import React from 'react';
import PropTypes from 'prop-types';
import { system as styledSystem } from '@styled-system/core';

import './UPSearchBar.less';

const UPSearchBar = ({ searchInput, onSearchInputChange, placeholder, ..._styles }) => {
  const styledParser = styledSystem({
    height: true,
    minWidth: true,
    maxWidth: true,
    marginLeft: true,
  });

  return (
    <div style={styledParser(_styles)}>
      <input
        value={searchInput}
        type="search"
        onChange={onSearchInputChange}
        placeholder={placeholder}
        styleName="searchInput"
      />
    </div>
  );
};

UPSearchBar.propTypes = {
  onSearchInputChange: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

UPSearchBar.displayName = 'UPSearchBar';

export default UPSearchBar;
